import { render, staticRenderFns } from "./TeamsportCompetitionInfo.vue?vue&type=template&id=c8893d36&scoped=true"
import script from "./TeamsportCompetitionInfo.vue?vue&type=script&lang=js"
export * from "./TeamsportCompetitionInfo.vue?vue&type=script&lang=js"
import style0 from "./TeamsportCompetitionInfo.vue?vue&type=style&index=0&id=c8893d36&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c8893d36",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VIcon})
